import { getAuthToken } from '../../core/utils/auth-token'

export const getAuthorizationHeader = async () => {
  const authorizationToken = await getAuthToken()

  return {
    Authorization: authorizationToken,
  }
}
